module.exports = {"150924106":"城关镇","150924107":"张皋镇","150924108":"赛乌素镇","150924109":"鄂尔栋镇","150924110":"店子镇","150924209":"大库联乡","150924210":"民族团结乡","150924211":"大同夭乡","150924212":"五股泉乡","150924400":"南部矿区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150924.json
// module id = 470
// module chunks = 0